var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatRefill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Category icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5833 4.58333C15.5833 5.84899 12.7105 6.875 9.16667 6.875C5.62284 6.875 2.75 5.84899 2.75 4.58333C2.75 3.31768 5.62284 2.29167 9.16667 2.29167C12.7105 2.29167 15.5833 3.31768 15.5833 4.58333Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#F2C230"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.75 4.58333V15.5833C2.75 16.8483 5.61917 17.875 9.16667 17.875",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#F2C230"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.5833 4.58333V9.16667",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#F2C230"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M2.75 10.0833C2.75 11.3483 5.61917 12.375 9.16667 12.375",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#F2C230"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M19.25 12.8333C19.25 13.5927 17.6084 14.2083 15.5833 14.2083C13.5583 14.2083 11.9167 13.5927 11.9167 12.8333C11.9167 12.0739 13.5583 11.4583 15.5833 11.4583C17.6084 11.4583 19.25 12.0739 19.25 12.8333Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#F2C230"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M11.9167 12.8333V17.4167C11.9167 18.1775 13.5575 18.7917 15.5833 18.7917C17.6092 18.7917 19.25 18.1775 19.25 17.4167V12.8333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#F2C230"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M11.9167 15.125C11.9167 15.8858 13.5575 16.5 15.5833 16.5C17.6092 16.5 19.25 15.8858 19.25 15.125",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#F2C230"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatRefill);
export default __webpack_public_path__ + "static/media/cat_refill.398b4aa5657a80272560e3820017994e.svg";
export { ForwardRef as ReactComponent };